import React, { FunctionComponent } from 'react'

import styled from 'styled-components'

import { Text, baseColors } from '@fairhq/common'

import { ArrowWithBackground } from 'components/ArrowWithBackground'

import { Recommendation } from 'store/strategy/types'
import { Task as TaskType } from 'store/tasks/types'

import RouterLink from 'ui-kit/RouterLink'

import { InitiativeTask } from './InitiativeTask'

const RecAndTasksContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 32px;
  width: 100%;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`

const LeftBox = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: space-between;
  align-self: stretch;

  @media (max-width: 800px) {
    width: 100%;
  }
`

const LeftBoxTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const List = styled.ul`
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: none;
  padding: 0;

  @media (max-width: 800px) {
    width: 100%;
  }
`

const StyledLink = styled(RouterLink)`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: start;
  &:focus-visible {
    outline: 2px solid ${baseColors.statesFocus};
    outline-offset: 2px;
    border-radius: 8px;
  }
`
interface InitiativeEditableProps {
  recommendation: Recommendation
  greyedOut?: boolean
  companyTasks: TaskType[]
}

export const Initiative: FunctionComponent<InitiativeEditableProps> = ({
  recommendation,
  greyedOut = false,
  companyTasks,
}) => (
  <RecAndTasksContainer>
    <LeftBox>
      <LeftBoxTop>
        <Text
          element="h3"
          type="body"
          size="lg"
          fontWeight={600}
          color={greyedOut ? baseColors.coolGrey800 : baseColors.purple900}
        >
          {recommendation.description}
        </Text>
        {recommendation.notionURL && (
          <StyledLink
            aria-label={`Open the guide: ${recommendation.description}`}
            to={`/strategy/recommendation/${recommendation.code}`}
          >
            <Text element="p" type="body" size="sm" fontWeight={500}>
              Open the guide
            </Text>
            <ArrowWithBackground />
          </StyledLink>
        )}
      </LeftBoxTop>
    </LeftBox>

    <List>
      {companyTasks.length > 0 &&
        companyTasks.map(companyTask => (
          <InitiativeTask
            key={companyTask.id}
            task={companyTask}
            greyedOut={greyedOut}
          />
        ))}
    </List>
  </RecAndTasksContainer>
)
